<template>
  <div class="linkbuilding">
    <div class="anchors-section">
      <h3>Anchor Links</h3>
      <div class="input-container">
        <label for="anchorlink">Anchor Link</label>
        <input :disabled="!isActive" class="input" id="anchorlink" v-model="task.content.anchors[0].link" />
      </div>
      <div class="input-container">
        <label for="anchortext">Anchor Text</label>
        <input :disabled="!isActive" class="input" id="anchortext" v-model="task.content.anchors[0].text" />
      </div>
    </div>
    <div class="info-section">
      <h3>Website and Topic</h3>
      <div class="input-container">
        <label for="url">Website</label>
        <input :disabled="!isActive" class="input" id="url" v-model="task.content.url" />
      </div>
      <div class="input-container">
        <label for="topic">Topic</label>
        <input :disabled="!isActive" class="input" id="topic" v-model="task.content.topic" />
      </div>
    </div>
    <div class="content-section">
      <h3>Content</h3>
      <div class="textarea-container">
        <label data-cy="content-words">Text ({{ wordCount(task.content.content) }} words)</label>
        <textarea :disabled="!isActive" class="textarea" id="content" rows="20" v-model="task.content.content"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sharedWordCountScript from '@/assets/shared-scripts/wordcount'

export default {
  created() {
    this.wordCount = sharedWordCountScript.wordCounter
  },
  props: {
    task: Object,
  },
  computed: {
    ...mapGetters(['user']),
    isActive() {
      const isAdmin = this.user.data.firestore.isAdmin
      const status = this.task.status

      if (isAdmin) {
        return status != 'available' ? false : true
      } else {
        return status == 'available' || status == 'claimed' || status == 'revision-needed' ? true : false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/checkbox.scss';
@import '@/assets/shared-styles/input.scss';
@import '@/assets/shared-styles/sections.scss';
@import '@/assets/shared-styles/select.scss';
@import '@/assets/shared-styles/textarea.scss';

.linkbuilding {
  background: white;
}
</style>
